// Глобальная длительность бесплатной подписки (в месяцах).
// Используется как единый источник правды для текста промо-баннера на главной
// и для расчёта/отображения периода подписки в профиле.
export const FREE_SUBSCRIPTION_MONTHS = 1

// Прибавляет к дате указанное число месяцев (без мутации исходной даты).
export function addMonths(date, months) {
  const result = new Date(date)
  result.setMonth(result.getMonth() + months)
  return result
}

// Возвращает дату окончания бесплатной подписки относительно даты начала.
export function getFreeSubscriptionEndDate(startDate) {
  return addMonths(new Date(startDate), FREE_SUBSCRIPTION_MONTHS)
}
